import { registerWorker } from '@reachmedianetwork/workbox-abstractions';
import { Workbox } from 'workbox-window';
import { getVersion } from '../../serviceWorker/version';
import { ExpirationModel, getExpiredVersions, updateVersion } from './database';

const FOUR_MINUTES = 4 * 60 * 1000;
/**
 * Wraps `initializeWorkbox` in a try catch to swallow any error.
 */
export async function tryInitializeWorkbox(): Promise<Workbox | undefined> {
    let workbox;
    try {
        const workboxLocation = new URL('serviceWorker.bundle.js', window.location.href);
        workbox = await registerWorker(workboxLocation, {
            timeToWaitBeforeRejection: FOUR_MINUTES,
        });
        const version = getVersion(window.location.href);
        await updateTimestamp(version);
        await unregisterWorkers(version);
    } catch (e) {
        console.error(e);
        return undefined;
    }
    return workbox;
}

async function updateTimestamp(version: string) {
    if (version === null) return;
    return updateVersion(version);
}

const MAX_AMOUT_OF_VERSIONS = 3;

async function unregisterWorkers(version: string) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    const expiredVersions = await getExpiredVersions(MAX_AMOUT_OF_VERSIONS);
    const versionToBeUnregistered = registrations
        .map((registration) => new URL(registration.scope))
        .filter(
            (url) =>
                url.pathname.startsWith('/v/') &&
                expiredVersions.some(
                    (expiredVersion) => expiredVersion.version === getVersion(url.href)
                ) &&
                expiredVersions.every((expiredVersion) => version !== expiredVersion.version)
        );
    void registrations.map(async (registration) => {
        if (versionToBeUnregistered.some((url) => url.href === registration.scope)) {
            return registration.unregister();
        }
        return false;
    });
    void clearExpiredCaches(expiredVersions);
}
async function clearExpiredCaches(expiredVersions: ExpirationModel[]) {
    const expiredKeys = expiredVersions.map(({ version }) => `signs-pre-${version}`);
    return await Promise.allSettled(expiredKeys.map((key) => self.caches.delete(key)));
}
